<div class="d-flex flex-column" [ngClass]="!totalSlides() ? 'd-none' : ''">
	<div class="mb-2">
		@if (activeTemplate()) {
			<ng-container
				[ngTemplateOutlet]="activeTemplate()"
				[ngTemplateOutletContext]="{
					$implicit: activeItem(),
					index: activeIndex(),
				}"
			/>
		} @else {
			<div class="text-muted">-</div>
		}
	</div>

	@if (showControls()) {
		<div class="carousel-btn-container">
			<button
				class="navigation-btn"
				type="button"
				[attr.aria-label]="previousButtonTitle()"
				[title]="previousButtonTitle()"
				(click)="previous()"
			>
				<i aria-hidden="true" class="far fa-chevron-left fa-xs"></i>
			</button>

			<div aria-label="Carousel pagination" class="carousel-dots">
				@for (item of items(); track $index; let index = $index) {
					<button
						class="carousel-dot"
						title="Show Slide {{ index + 1 }}"
						type="button"
						[attr.aria-current]="index === activeIndex() ? 'true' : null"
						[ngClass]="
							index === activeIndex()
								? 'fas fa-circle text-primary'
								: 'far fa-circle'
						"
						(click)="selectSlide(index)"
					></button>
				}
			</div>

			<button
				class="navigation-btn"
				type="button"
				[attr.aria-label]="nextButtonTitle()"
				[title]="nextButtonTitle()"
				(click)="next()"
			>
				<i aria-hidden="true" class="far fa-chevron-right fa-xs"></i>
			</button>
		</div>
	}
</div>
